export default __webpack_public_path__ + "static/media/table-sort-icon.d82581a9.svg";